export default "__VITE_ASSET__3$I0V$$i__"